import { HStack, VStack } from '@chakra-ui/react';
import React from 'react';
import { useParams } from 'react-router-dom';

import { BackButton, EditButton } from '../../../../components/StyledButton';
import { pageKeywords, pagePaths } from '../../../../constants/Page';
import { useGlobalStateMachine } from '../../../../GlobalStore';
import { useEngeneNavigate } from '../../../../hooks/navigate';
import { useSizeContext } from '../../../SizeProvider';
import { UserInfoAccordion } from '../../user-info/accordion/UserInfoAccordion';
import { OutsourcerWorkerParams } from './Worker';

/**
 * 外注メンバ画面 閲覧モード
 * @returns
 */
const OutsourcerWorkerView: React.FunctionComponent = () => {
  const { state } = useGlobalStateMachine();
  const navigate = useEngeneNavigate();
  const params = useParams<OutsourcerWorkerParams>();
  const sizes = useSizeContext();

  return (
    <VStack width="100%">
      <UserInfoAccordion
        defaultIndex={state.pageInfo.WORKER_MANAGEMENT?.openedPanel || 0}
        isOutsourcer
        mode="view"
      />
      <EditButton
        onClick={() =>
          navigate(
            `${pagePaths.WORKER}/${params.outsourcerMemberId}/${pageKeywords.mode.EDIT}`
          )
        }
      />
      <HStack width={sizes.width.styledMessageList}>
        <BackButton onClick={() => navigate(-1)} />
      </HStack>
    </VStack>
  );
};

export default OutsourcerWorkerView;
